import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customer__container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "details-block" }
const _hoisted_4 = { class: "details-row details-row--adaptive" }
const _hoisted_5 = { class: "details-value" }
const _hoisted_6 = { class: "details-row details-row--adaptive" }
const _hoisted_7 = { class: "details-value" }
const _hoisted_8 = { class: "details-row details-row--adaptive" }
const _hoisted_9 = { class: "details-value" }
const _hoisted_10 = { class: "details-row details-row--adaptive" }
const _hoisted_11 = { class: "details-value" }
const _hoisted_12 = { class: "details-row details-row--adaptive" }
const _hoisted_13 = { class: "details-value" }
const _hoisted_14 = { class: "details-row details-row--adaptive" }
const _hoisted_15 = { class: "details-value" }
const _hoisted_16 = { class: "details-row details-row--adaptive" }
const _hoisted_17 = { class: "details-value" }
const _hoisted_18 = { class: "controls" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "modal-wrapper" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "customer__title" }, "My Profile", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "customer__sub-title" }, "Profile Details", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "details-label" }, "Name", -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.user.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "details-label" }, "Middle Name(s)", -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.user.middleName), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "details-label" }, "Last Name", -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.user.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "details-label" }, "Email", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.user.email), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "details-label" }, "Phone Number", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.user.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "details-label" }, "Postcode", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.user.detailsId?.postcode? $setup.user.detailsId.postcode
: $setup.user.detailsId?.state), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "details-label" }, "Address", -1)),
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.user.detailsId?.address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "button primary",
            onClick: $setup.onEdit
          }, "Edit Info"),
          _createElementVNode("button", {
            class: "button button-with-icon",
            onClick: $setup.onChangePassword
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/icons/lock.svg`)
            }, null, 8, _hoisted_19),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Change Password", -1))
          ]),
          _createElementVNode("button", {
            class: "button button-with-icon delete",
            onClick: $setup.onDelete
          }, [
            _createElementVNode("img", {
              class: "warning-icon",
              src: require(`@/assets/icons/icon-bucket.svg`)
            }, null, 8, _hoisted_20),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Delete Account", -1))
          ])
        ])
      ])
    ]),
    _createVNode($setup["Modal"], {
      isOpen: $setup.isDeleteAccountModal,
      onClose: $setup.onCancel
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal__title" }, "Confirm action", -1)),
          (!$setup.isErrorOnDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "modal__description" }, "Are you sure you want to delete account?", -1)),
                _createElementVNode("div", { class: "modal-controls" }, [
                  _createElementVNode("button", {
                    class: "button modal cancel",
                    onClick: $setup.onCancel
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "button modal primary",
                    onClick: $setup.deleteAccount
                  }, "Delete")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "warning-block" }, [
                  _createElementVNode("div", null, "You have one or more active lots. Please close them first.You can decline or withdraw your request at the Contract information form tab on the lot details page."),
                  _createElementVNode("div", null, "Please pay attention that you need to wait for the approval from land sales agent if you have withdrawn your request.")
                ], -1)),
                _createElementVNode("div", { class: "modal-controls" }, [
                  _createElementVNode("button", {
                    class: "button modal cancel",
                    onClick: $setup.onCancel
                  }, "Cancel"),
                  _createElementVNode("button", {
                    class: "button modal primary",
                    onClick: $setup.onProceed
                  }, "Proceed")
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}